import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword.length < 8 || !/\d/.test(newPassword)) {
            setError('Password must be at least 8 characters and include a number.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setIsSubmitting(true);
        try {
            await api.resetPassword(token, newPassword);
            setSuccess(true);
            setTimeout(() => navigate('/'), 2500);
        } catch (err) {
            setError(err.message || 'Invalid or expired reset link.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050d1f] text-white flex items-center justify-center p-4">
            <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-[#4d7cff]/10 rounded-full blur-[120px]" />

            <div className="relative w-full max-w-md">
                <div className="absolute -inset-0.5 bg-[#4d7cff]/20 rounded-[32px] blur-sm" />
                <div className="relative bg-[#0c1526]/95 backdrop-blur-2xl border border-white/[0.08] rounded-[32px] p-10">
                    <h1 className="text-2xl font-bold mb-1 text-[#4d7cff]">PlayerIQ</h1>
                    <h2 className="text-xl font-semibold mb-2">Set a new password</h2>
                    <p className="text-white/50 text-sm mb-8">Choose a strong password for your account.</p>

                    {error && (
                        <div className="mb-6 px-5 py-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 text-sm">
                            {error}
                        </div>
                    )}

                    {success ? (
                        <div className="px-5 py-4 rounded-xl bg-green-500/10 border border-green-500/30 text-green-400 text-sm text-center">
                            Password updated! Redirecting to login…
                        </div>
                    ) : !token ? (
                        <div className="px-5 py-4 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 text-sm text-center">
                            Invalid reset link. Please request a new one.
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <input
                                type="password"
                                placeholder="New password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="w-full bg-white/10 rounded-full px-7 py-4 text-white outline-none focus:ring-2 focus:ring-[#4d7cff]/30"
                                required
                            />
                            <input
                                type="password"
                                placeholder="Confirm new password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full bg-white/10 rounded-full px-7 py-4 text-white outline-none focus:ring-2 focus:ring-[#4d7cff]/30"
                                required
                            />
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="w-full bg-[#4d7cff] rounded-full px-7 py-4 text-white text-lg font-bold shadow-[0_8px_24px_rgba(77,124,255,0.3)] hover:bg-[#3d6cef] transition-all disabled:opacity-70"
                            >
                                {isSubmitting ? 'Updating…' : 'Update Password'}
                            </button>
                        </form>
                    )}

                    <p className="mt-6 text-center text-white/40 text-sm">
                        <button type="button" onClick={() => navigate('/')} className="text-[#4d7cff] hover:underline">
                            Back to login
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
